import type { User } from '../../types';
import { UserApiClient } from '../UserApiClient';

export const UserInfoApi = UserApiClient.injectEndpoints({
    endpoints: (build) => ({
        getUserDetails: build.query<User, void>({
            query: () => ({
                url: 'userinfo',
            }),
        }),
    }),
});

export const { useGetUserDetailsQuery } = UserInfoApi;
